import axios from "./axiosInstance";

const BannerAPI = {
  getDetails: () => axios.get("banners/"),

  addDetails: (payload) => axios.post("banners/", payload),

  getSingleDetails: (id) => axios.get(`banners/${id}`),

  updateDetails: (id, payload) => axios.put(`banners/${id}`, payload),

  updateStatus: (id) => axios.patch(`banners/${id}/status`),

  updateOrder: (payload) => axios.put("banners/reorder", payload),

  deleteItem: (id) => axios.delete(`banners/${id}`),
};

export default BannerAPI;
